import { BorderedSection, Text } from '@capsicum/common-web';
import { type V2FTSupportedDestinationsProps } from '@capsicum/features/nc-wallet/shared';
import styled from 'styled-components';

export const V2FTSupportedDestinationsComponent = ({ destinations, testID, title }: V2FTSupportedDestinationsProps) => {
	return (
		destinations.length > 0 && (
			<S.Wrapper>
				<BorderedSection testID={testID} title={title} titleInsideSection>
					{destinations.map(destination => (
						<S.Destination key={destination} variant="text4">
							{destination}
						</S.Destination>
					))}
				</BorderedSection>
			</S.Wrapper>
		)
	);
};

namespace S {
	export const Wrapper = styled.div`
		flex: 1;
	`;

	export const Destination = styled(Text)`
		padding: ${({ theme }) => theme.spacings.xxsmall};
	`;
}
